import { Component, Input, OnChanges, SimpleChanges, OnDestroy } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Component({
  selector: "number-counter",
  templateUrl: "number-counter.component.html",
  styleUrls: ["number-counter.component.scss"]
})
export class NumberCounterComponent implements OnChanges, OnDestroy {

  @Input("number") number: number = 0;
  @Input("duration") duration: number = 400;

  counter = new BehaviorSubject<number>(0);

  private timer: any = null;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['number'] && this.number != null) {
      this.counterFunc();
    }
  }

  ngOnDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  counterFunc() {
    if (this.timer) {
      clearInterval(this.timer);
    }

    const end = Math.round(this.number || 0);

    if (end === 0) {
      this.counter.next(0);
      return;
    }

    let start = 0;

    const steps = Math.min(Math.abs(end), 10);
    const increment = end / steps;
    const stepDuration = this.duration / steps;

    this.counter.next(0);
    this.timer = setInterval(() => {
      start += increment;

      if ((increment > 0 && start >= end) || (increment < 0 && start <= end)) {
        this.counter.next(end);
        clearInterval(this.timer);
        this.timer = null;
      } else {
        this.counter.next(Math.round(start));
      }
    }, stepDuration);
  }
}
